
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Case Battles',
    tabActive: 'Active',
    tabHistoryAll: 'Completed',
    tabHistoryMine: 'My Battles',
    createBattle: 'Create Battle',
    empty: 'No active battles',
    emptyHistory: 'No battle history',
    loading: 'Loading...',
    historyMineLoginReason: 'Sign in to see your battles.',
  },
  ru: {
    title: 'Кейс Баттлы',
    tabActive: 'Активные',
    tabHistoryAll: 'Завершенные',
    tabHistoryMine: 'Мои баттлы',
    createBattle: 'Создать баттл',
    empty: 'Нет активных баттлов',
    emptyHistory: 'Нет истории баттлов',
    loading: 'Загрузка...',
    historyMineLoginReason: 'Войди, чтобы видеть свои баттлы.',
  },
  uz: {
    title: 'Keys Janglar',
    tabActive: 'Faol',
    tabHistoryAll: 'Tugallangan',
    tabHistoryMine: 'Mening janglarim',
    createBattle: "Jang yaratish",
    empty: "Faol janglar yo'q",
    emptyHistory: "Jang tarixi yo'q",
    loading: 'Yuklanmoqda...',
    historyMineLoginReason: 'O\'z janglaringizni ko\'rish uchun kiring.',
  },
});
